import React, { useState } from "react";
import { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Link } from "react-router-dom";
import {
  fatchFilteredTransaction,
  fetchTransactions,
} from "../../features/transaction/transactionSlice";
import Filter from "../Filter";
import Form from "../Form";
import ItemPerPage from "../ItemPerPage";
import Page from "../Page";
import Transaction from "./Transaction";

export default function AllTransaction({ triggerEdit, setTriggerEdit }) {
  const dispatch = useDispatch();
  const { transactions, filteredTransaction, isLoading, isError } = useSelector(
    (state) => state.transaction
  );
  const [pageNumber, setPageNumber] = useState(1);
  const [itemNoPerPage, setItemNoPerPage] = useState(10);
  const [type, setType] = useState("");
  const [productName, setProductName] = useState("");
  const handlePageNumber = (pageNumber) => {
    setPageNumber(pageNumber);
  };
  useEffect(() => {
    dispatch(fetchTransactions());
    dispatch(
      fatchFilteredTransaction({ pageNumber, itemNoPerPage, type, productName })
    );
  }, [dispatch, pageNumber, itemNoPerPage, type, productName]);

  const handleReset = () => {
    setItemNoPerPage(10);
    setPageNumber(1);
    setProductName("");
    setType("");
  };
  //calculate page number
  let allItem;
  let filteredByType = transactions.filter((el) => el.type === type);

  if (type !== "") {
    allItem = filteredByType.length;
  } else if (productName !== "") {
    allItem = filteredTransaction.length;
  } else {
    allItem = transactions.length;
  }

  const pageNumbers = Array(Math.ceil(allItem / itemNoPerPage)).fill("");

  // decide what to render
  let content = null;
  if (isLoading) content = <p>Loading...</p>;

  if (!isLoading && isError)
    content = <p className="error">There was an error occured</p>;

  if (!isLoading && !isError && filteredTransaction?.length > 0) {
    content = filteredTransaction.map((transaction) => (
      <Transaction
        key={transaction.id}
        transaction={transaction}
        setTriggerEdit={setTriggerEdit}
      />
    ));
  }

  if (!isLoading && !isError && filteredTransaction?.length === 0) {
    content = <p>No transactions found!</p>;
  }
  return (
    <>
      <div className="flex filter-container">
        <div className="filter">
          <p>Filter & Search Transaction</p>
          <Filter
            setType={setType}
            type={type}
            productName={productName}
            setProductName={setProductName}
            handleReset={handleReset}
            setPageNumber={setPageNumber}
          />
        </div>
        <div className="ml-10">
          <p className="second_heading">Your Transactions:</p>
          <div className="conatiner_of_list_of_transactions">
            {triggerEdit && <Form setTriggerEdit={setTriggerEdit} />}
            <ul className="showtransaction">{content}</ul>
          </div>
          <div className="flex space-between">
            <ItemPerPage
              setItemNoPerPage={setItemNoPerPage}
              itemNoPerPage={itemNoPerPage}
            />
            <div className="b-pagination-outer ml-10">
              <ul id="border-pagination">
                {pageNumber > 1 ? (
                  <li
                    className="cursor"
                    onClick={() => handlePageNumber(pageNumber - 1)}
                  >
                    «
                  </li>
                ) : (
                  <li>«</li>
                )}
                {pageNumbers.map((_, index) => (
                  <Page
                    page={index + 1}
                    pageNumber={pageNumber}
                    key={index}
                    handlePageNumber={handlePageNumber}
                  />
                ))}
                {pageNumber < pageNumbers.length ? (
                  <li
                    className="cursor"
                    onClick={() => handlePageNumber(pageNumber + 1)}
                  >
                    »
                  </li>
                ) : (
                  <li>»</li>
                )}
              </ul>
            </div>
          </div>
        </div>
      </div>
      <button className="seemore">
        <Link to="/">Back To Home</Link>
      </button>
    </>
  );
}
